class FaqController {
    constructor() {

        this.setQaToggle();
    }

    setQaToggle() {
        let $item = $('#js-faq-content__qa-items-toggle .faq-content__qa-item');
        $item.each(function(){
            let $this = $(this);
            $this.find('.faq-content__qa-item-q').on('click', function(e){
                $(this).toggleClass('is-open');
                e.preventDefault();
                $this.find('.faq-content__qa-item-a').slideToggle(100);
            });
        });
    }
}

export default FaqController;
